export const currency = "USD";

export const formatPrice = (
  price: string | number = 0,
  locale = "en-US",
  currencyType = currency
) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyType,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(Number(price || 0));
};

export const addZeroIfInRange = (num: number) => {
  if (num < 10 && num > -10) {
    return num < 10 && num >= 0 ? `0${num}` : `-0${Math.abs(num)}`;
  }

  return num;
};

export const countParPageSerialNumber = (
  page: number,
  limit: number,
  index: number
) => {
  return index + 1 + (page - 1) * limit;
};

// sum all data
export const calculateSumOfArray = (arr: any[], field: string) => {
  return arr?.reduce((acc, curr) => acc + curr?.[field] || 0, 0);
};

export const addCommaInNumber = (number: number | string) => {
  return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const calculatePercentage = (value: number, total: number) => {
  return (value / total) * 100;
};

export function numberShortFormat(number: number) {
  if (number >= 1000 && number < 1000000) {
    return (number / 1000).toFixed(2).replace(/\.00$/, "") + "K";
  } else if (number >= 1000000 && number < 1000000000) {
    return (number / 1000000).toFixed(2).replace(/\.00$/, "") + "M";
  } else if (number >= 1000000000) {
    return (number / 1000000000).toFixed(2).replace(/\.00$/, "") + "B";
  } else {
    return number.toString();
  }
}

export function generateUUID() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & 15)) >>
      (+c / 4)
    ).toString(16)
  );
}

export function percentageCalculate(
  totalSalary: number,
  percentage: number
): number {
  return (totalSalary * percentage) / 100;
}

export function fixedNumber(number: number, fixed = 2) {
  return number ? number?.toFixed(fixed) : 0;
}

export interface TaxDetailsType {
  totalTaxableIncome: number;
  exemptionAmount: number;
  remainingTaxableIncome: number;
  slab5: number;
  slab10: number;
  slab15: number;
  slab20: number;
  totalTaxAmountYearly: number;
  totalTaxAmountMonthly: number;
}

export const calculateTax = (
  grossSalary: number,
  gender?: "male" | "female"
): TaxDetailsType => {
  let exemption = gender === "male" ? 350000 : 400000;
  let remainingTaxableIncome = Math.max(grossSalary - exemption, 0);

  let slab5 = 0,
    slab10 = 0,
    slab15 = 0,
    slab20 = 0,
    tax = 0;

  if (remainingTaxableIncome > 0) {
    if (remainingTaxableIncome <= 100000) {
      slab5 = remainingTaxableIncome * 0.05;
    } else {
      slab5 = 100000 * 0.05;
      remainingTaxableIncome -= 100000;

      if (remainingTaxableIncome <= 400000) {
        slab10 = remainingTaxableIncome * 0.1;
      } else {
        slab10 = 400000 * 0.1;
        remainingTaxableIncome -= 400000;

        if (remainingTaxableIncome <= 500000) {
          slab15 = remainingTaxableIncome * 0.15;
        } else {
          slab15 = 500000 * 0.15;
          remainingTaxableIncome -= 500000;

          slab20 = remainingTaxableIncome * 0.2;
        }
      }
    }
  }

  tax = slab5 + slab10 + slab15 + slab20;

  if (tax > 0 && tax < 5000) {
    tax = 5000;
  }

  return {
    totalTaxableIncome: grossSalary,
    exemptionAmount: exemption,
    remainingTaxableIncome,
    slab5,
    slab10,
    slab15,
    slab20,
    totalTaxAmountYearly: tax,
    totalTaxAmountMonthly: tax / 12,
  };
};
